<button pButton type="button" [disabled]="to.disabled" label="+ สำหรับเพิ่มตำแหน่งงานใหม่"
  (click)="showCreateDialog()"></button>